import script from "./WorkspaceTasksTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceTasksTab.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceTasksTab.vue?vue&type=style&index=0&id=038e3175&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038e3175"]])

export default __exports__